import * as angular from "angular";

/** @internal */
export function getValueTextFilter() {

    return (value, source) => {

        if (angular.isArray(source)) {
            var item = source.find(i => i.Key == value);
            if (item) value = item.Value;
        }

        return value;

    }

}
